import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import Clientes from '../../Clientes';
import Indices from '../../Indices';
import Fornecedor from '../../Fornecedor';
import Kits from '../../Kits';
import Servicos from '../../Servicos';
import Produtos from '../../Produtos';
import Operadoras from '../../Operadoras';
import Metas from '../../Metas';
import Contas from '../../Contas';
import Obras from '../../Obras';
import Bandeiras from '../../Bandeiras';
import EmissorBoletos from '../../EmissorBoletos';
import CentrosCustos from '../../CentrosCustos';
import { cores } from '../../../styles/styleUtils';

const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const ScrollButton = styled.button`
  border: 0px solid ${cores.cinzaClaro};
  font-size: 1.2rem;
  padding: 4px 10px;
  cursor: pointer;
  z-index: 1;
  height: 45px;
`;

const TabContainer = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  background-color: ${cores.cinzaClaro};
  border-bottom: 1px solid ${cores.cinzaClaro};
  padding: 5px 0;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  flex: 1;
`;

const TabButton = styled.button`
  background: none;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 0.875rem;
  color: ${cores.cinzaMedio};
  border-bottom: 2px solid transparent;
  transition: border-bottom 0.3s ease;
  flex-shrink: 0;
  min-width: 120px;

  &:hover {
    color: ${cores.chumbo};
  }

  &.active {
    color: ${cores.laranja};
    border-bottom: 2px solid ${cores.laranja};
  }
`;

const TabContent = styled.div`
  padding: 20px;
`;

const Cadastros = () => {
  const [activeTab, setActiveTab] = useState('cliente');
  const tabRef = useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const scrollLeft = () => {
    if (tabRef.current) {
      tabRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (tabRef.current) {
      tabRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    }
  };

  return (
    <div>
      <TabWrapper>
        <ScrollButton onClick={scrollLeft}>{'<'}</ScrollButton>
        <TabContainer ref={tabRef}>
          <TabButton className={activeTab === 'cliente' ? 'active' : ''} onClick={() => handleTabClick('cliente')}>
            Clientes
          </TabButton>
          <TabButton className={activeTab === 'indice' ? 'active' : ''} onClick={() => handleTabClick('indice')}>
            Indicadores
          </TabButton>
          <TabButton
            className={activeTab === 'fornecedor' ? 'active' : ''}
            onClick={() => handleTabClick('fornecedor')}
          >
            Fornecedores
          </TabButton>
          <TabButton className={activeTab === 'kit' ? 'active' : ''} onClick={() => handleTabClick('kit')}>
            Kits
          </TabButton>
          <TabButton className={activeTab === 'servico' ? 'active' : ''} onClick={() => handleTabClick('servico')}>
            Serviços
          </TabButton>
          <TabButton className={activeTab === 'modulo' ? 'active' : ''} onClick={() => handleTabClick('modulo')}>
            Módulos
          </TabButton>
          <TabButton className={activeTab === 'inversor' ? 'active' : ''} onClick={() => handleTabClick('inversor')}>
            Inversores
          </TabButton>
          <TabButton className={activeTab === 'operadora' ? 'active' : ''} onClick={() => handleTabClick('operadora')}>
            Operadoras
          </TabButton>
          <TabButton
            className={activeTab === 'emissorboleto' ? 'active' : ''}
            onClick={() => handleTabClick('emissorboleto')}
          >
            Emissor Boleto
          </TabButton>
          <TabButton className={activeTab === 'meta' ? 'active' : ''} onClick={() => handleTabClick('meta')}>
            Metas
          </TabButton>
          <TabButton
            className={activeTab === 'centrocusto' ? 'active' : ''}
            onClick={() => handleTabClick('centrocusto')}
          >
            Centros de Custo
          </TabButton>

          <TabButton className={activeTab === 'conta' ? 'active' : ''} onClick={() => handleTabClick('conta')}>
            Contas
          </TabButton>
          <TabButton className={activeTab === 'obra' ? 'active' : ''} onClick={() => handleTabClick('obra')}>
            Obras
          </TabButton>
          <TabButton className={activeTab === 'bandeira' ? 'active' : ''} onClick={() => handleTabClick('bandeira')}>
            Bandeiras
          </TabButton>
        </TabContainer>
        <ScrollButton onClick={scrollRight}>{'>'}</ScrollButton>
      </TabWrapper>

      <TabContent>
        {activeTab === 'cliente' && <Clientes />}
        {activeTab === 'indice' && <Indices />}
        {activeTab === 'fornecedor' && <Fornecedor />}
        {activeTab === 'kit' && <Kits />}
        {activeTab === 'servico' && <Servicos />}
        {activeTab === 'modulo' && <Produtos type={'modulos'} />}
        {activeTab === 'inversor' && <Produtos type={'inversores'} />}
        {activeTab === 'operadora' && <Operadoras />}
        {activeTab === 'emissorboleto' && <EmissorBoletos />}
        {activeTab === 'meta' && <Metas />}
        {activeTab === 'centrocusto' && <CentrosCustos />}
        {activeTab === 'conta' && <Contas />}
        {activeTab === 'obra' && <Obras />}
        {activeTab === 'bandeira' && <Bandeiras />}
      </TabContent>
    </div>
  );
};

export default Cadastros;